export const IndustrialPlant = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 2V5C11.5 6.65685 12.8434 8 14.5002 8H15.5C17.5 8 18.5 9 18.5 10M18.5 21H21.5V12H18.5V16.5M18.5 21V16.5M18.5 21H3.5V17L7 14L11 16.5L15 14L18.5 16.5M17.7677 4.02362C17.5997 4 17.5 4 17.5 4C17.5 4 17.5997 4.01247 17.7677 4.02362ZM17.7677 4.02362C18.6634 4.14958 21.5 4.94737 21.5 10M17.7677 4.02362C18.6634 4.0831 21.5 4.10526 21.5 2"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
